import { Box, TextField } from "@mui/material";
import ReadOnlyAdditionalResourceLinkAnchor from "./ReadOnlyAdditionalResourceLinkAnchor";
import LinkSolutionToStripeButton from "../actions/LinkSolutionToStripeButton";
import SectionCollapsible from "../../../common/SectionCollapsible";
import ExternalLinkAnchor from "../../../common/ExternalLinkAnchor";

export type InternalDetails = {
  websiteUrl: string;
  xeroAccountNumber: string;
  researchTeamNotes: string;
  additionalResourceLink: string;
  stripeProductUrl: string;
};

export function ReadOnlyInternalDetailsContainer({
  linkToStripe,
  internalDetails,
}: {
  linkToStripe: {
    link: () => void;
    loading: boolean;
  };
  internalDetails: InternalDetails;
}) {
  return (
    <Box data-testid="read-only-internal-details-container">
      <SectionCollapsible label="Internal Use Only">
        <TextField
          value={internalDetails?.websiteUrl || "-"}
          variant="standard"
          id="website-url"
          label="Earthly.org page url"
          size="small"
          fullWidth
          sx={{
            marginBottom: 2,
          }}
          slotProps={{
            htmlInput: {
              readOnly: true,
            },
          }}
        />
        <TextField
          value={internalDetails?.xeroAccountNumber || "-"}
          variant="standard"
          id="xero-account-number"
          label="Xero Account Number"
          size="small"
          fullWidth
          sx={{
            marginBottom: 2,
          }}
          slotProps={{
            htmlInput: {
              readOnly: true,
            },
          }}
        />
        <Box sx={{ paddingBottom: 2 }}>
          <ReadOnlyAdditionalResourceLinkAnchor
            url={internalDetails?.additionalResourceLink}
          />
        </Box>
        <TextField
          value={internalDetails?.researchTeamNotes || "-"}
          variant="standard"
          multiline
          id="research-team-notes"
          label="Research Team Supplementary Notes"
          size="small"
          fullWidth
          sx={{
            marginBottom: 2,
          }}
          slotProps={{
            htmlInput: {
              readOnly: true,
            },
          }}
        />
        {internalDetails?.stripeProductUrl ? (
          <Box sx={{ width: "33%", display: "flex" }}>
            <ExternalLinkAnchor
              url={internalDetails.stripeProductUrl}
              label="Stripe"
              dataTestid="open-stripe-solution-anchor"
            />
          </Box>
        ) : (
          <Box sx={{ width: "33%", display: "flex" }}>
            <LinkSolutionToStripeButton linkToStripe={linkToStripe} />
          </Box>
        )}
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyInternalDetailsContainer;
